import * as React from 'react';
import * as styles from './styles.css';
import { ArticleParagraph1, Image, Tooltip, UIText1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import PriceIcon from './assets/price.svg';
import { trackGoToValuationInfo } from '../../../../containers/PriceAverageContainer/tracking';
import { LINK_TEXT } from '../../../../containers/PriceAverageContainer/static';
import { IconHeadCard } from '../../../packages/IconHeadCard';
import { IPriceAverageProps } from '../../types';
import { EAnchorBlock } from '../../../../repositories/price-estimator/entities/onboardings/TooltipSchema';

type TPriceAverageProps = IPriceAverageProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function PriceAverage(props: TPriceAverageProps): React.JSX.Element {
  const {
    price,
    priceRange,
    openModal,
    changes,
    isWebview,
    closeModal,
    isModalOpen,
    isDesktop,
    isChartOpen,
    setIsChartOpen,
    chart,
    isChartAvailable,
    onOpenInformer,
    tooltipContent,
    ref,
  } = props;

  return (
    <div data-testid="price-average-component" ref={ref} className={styles['container']}>
      <Tooltip
        title={
          <div className={styles['tooltip-title']}>
            <ArticleParagraph1>
              {tooltipContent.text}{' '}
              {!isWebview && (
                <a onClick={trackGoToValuationInfo} className={styles['link']} href={tooltipContent.link}>
                  {LINK_TEXT}
                </a>
              )}
            </ArticleParagraph1>
          </div>
        }
        onOpen={onOpenInformer}
        header={tooltipContent.title}
        onClose={closeModal}
        open={isDesktop ? undefined : isModalOpen}
        theme={isDesktop ? 'white' : 'black'}
        placement={isDesktop ? 'bottom-end' : 'bottom'}
      >
        <div
          id={EAnchorBlock.Estimation}
          onClick={openModal}
          className={styles['item']}
          data-testid="market_price_value"
        >
          <IconHeadCard icon={<Image src={PriceIcon} />} title={priceRange} description={price} haveHelpIcon />
        </div>
      </Tooltip>
      {changes && (
        <div className={styles['item']} data-testid="market_price_range_value">
          <IconHeadCard
            icon={<Image borderRadius={0} src={changes.icon} />}
            title={changes.text}
            description="Изменение за полгода"
          >
            {isChartAvailable && !isChartOpen && !isDesktop && (
              <div data-testid="open-chart-id" onClick={setIsChartOpen} className={styles['chart-content']}>
                <UIText1 color="text-main-default">Как менялась оценка</UIText1>
                <div className={styles['icon']}>
                  <IconActionChevronDownSmall16 color="icon-main-default" display="inline-block" />
                </div>
              </div>
            )}
          </IconHeadCard>
        </div>
      )}
      {!isDesktop && isChartOpen && chart}
    </div>
  );
}
